import type { QuoteDestination } from '@repo/api-contracts';
import type { QuoteDocumentDestination } from './quote-document';

/**
 * 견적 배송지 → 견적서 배송지 표 한 줄(SUPER-86) — 발행본 배송비 줄과 맞출 견적 배송지 id 를 함께 싣는다. web·admin 견적 상세가 같이 쓴다.
 */
export const quoteDestinationsForDocument = (
  destinations: readonly QuoteDestination[],
): QuoteDocumentDestination[] =>
  destinations.map(
    ({ id, recipientName, recipientPhone, postalCode, address1, address2, quantity, sizes }) => ({
      quoteDestinationId: id,
      recipientName,
      recipientPhone,
      postalCode,
      address1,
      address2,
      quantity,
      sizes,
    }),
  );
